<div class="relative flex justify-center md:justify-start px-8 md:px-16 lg:px-64 align-middle hero">
    <div class="flex flex-col">
        <h1 class="text-3xl md:text-5xl leading-snug">
            <span class="block">Io penso che il</span>
            <span class="block">divertimento sia una</span>
            <span class="relative quote">cosa seria.</span>
        </h1>
        <span class="mt-6 font-mono text-slate-500 text-xl italic">Italo Calvino</span>
    </div>
    <div class="w-1/2 md:w-72 h-1/2 md:h-72 overflow-clip logo">
        <div class="wrapper">
            <img class="c" src="../../../assets/images/logo-c.svg" alt="Logo Teatro Colosseo">
            <img class="circle" id="logo-circle" src="../../../assets/images/logo-circle.svg" alt="Logo Teatro Colosseo">
        </div>
    </div>
</div>

<div class="home-media relative w-full overflow-hidden" [ngClass]="{'bg-dark': !hasCustomImmagine && !loading}">
    <ng-container *ngIf="hasCustomVideo && !loading">
        <video #video (pause)="onPause($event)" [autoplay]="true" [muted]="true" [loop]="true" class="home-media-asset" oncontextmenu="return false;" disablePictureInPicture playsinline [src]="(getVideoSrc() | file)"></video>
        <button type="button" class="home-media-mute" (click)="onMute(muted)" [attr.aria-label]="muted ? 'Attiva audio' : 'Disattiva audio'">
            <i class="bi text-2xl lg:text-3xl" [ngClass]="{'bi-volume-mute-fill': muted, 'bi-volume-up-fill': !muted}"></i>
        </button>
        <div class="home-media-cta" *ngIf="showPulsanteHome">
            <a class="block text-center btn btn-primary btn-sm" [href]="configurazione_home!.link" target="_blank" *ngIf="!isPulsanteFile">{{ configurazione_home!.testo_link }}</a>
            <a class="block text-center btn btn-primary btn-sm" [href]="configurazione_home!.file | pdf" target="_blank" *ngIf="isPulsanteFile">{{ configurazione_home!.testo_link }}</a>
        </div>
    </ng-container>

    <ng-container *ngIf="hasCustomImmagine && !loading">
        <img #img_home class="home-media-asset" [src]="configurazione_home!.immagine ? (configurazione_home!.immagine + '?type=home' | image) : ''" (error)="img_home.src='../../../assets/images/logo.svg'" alt="Evidenza home">
        <div class="home-media-scrim"></div>
        <div class="home-media-panel">
            <div class="mb-4 md:mb-8">
                <span class="p-2 border border-solid border-white/80 text-white text-xs uppercase grow-0">Highlights</span>
            </div>
            <div class="relative mb-4" *ngIf="configurazione_home?.testo">
                <h1 class="font-bold text-2xl md:text-3xl uppercase text-white" [innerHTML]="configurazione_home?.testo"></h1>
                <div class="top-0 -left-4 absolute bg-accent rounded w-[4px] h-full"></div>
            </div>
            <a class="block text-center btn btn-primary btn-sm" [href]="configurazione_home!.link" target="_blank" *ngIf="showPulsanteHome && !isPulsanteFile">{{ configurazione_home!.testo_link }}</a>
            <a class="block text-center btn btn-primary btn-sm" [href]="configurazione_home!.file | pdf" target="_blank" *ngIf="showPulsanteHome && isPulsanteFile">{{ configurazione_home!.testo_link }}</a>
        </div>
    </ng-container>

    <ng-container *ngIf="showSpettacoloEvidenza && !loading">
        <video #video (pause)="onPause($event)" [autoplay]="true" [muted]="true" [loop]="true" class="home-media-asset" oncontextmenu="return false;" disablePictureInPicture playsinline [src]="(getVideoSrc() | file)" *ngIf="video_spettacolo.length > 0"></video>
        <img #imgDesktop class="home-media-asset hidden lg:block" [src]="evidenzaImgDesktop ? (evidenzaImgDesktop + '?type=spettacolo' | image) : '../../../assets/images/logo.svg'" (error)="imgDesktop.src='../../../assets/images/logo.svg'" *ngIf="showSpettacoloImmagine" alt="Spettacolo in Evidenza">
        <img #imgMobile class="home-media-asset lg:hidden" [src]="evidenzaImgMobile ? (evidenzaImgMobile + '?type=spettacolo' | image) : '../../../assets/images/logo.svg'" (error)="imgMobile.src='../../../assets/images/logo.svg'" *ngIf="showSpettacoloImmagine" alt="Spettacolo in Evidenza">
        <div class="home-media-scrim"></div>

        <button type="button" class="home-media-mute" (click)="onMute(muted)" *ngIf="video_spettacolo.length > 0" [attr.aria-label]="muted ? 'Attiva audio' : 'Disattiva audio'">
            <i class="bi text-2xl lg:text-3xl" [ngClass]="{'bi-volume-mute-fill': muted, 'bi-volume-up-fill': !muted}"></i>
        </button>

        <div class="home-media-panel">
            <div class="mb-4 md:mb-8">
                <span class="p-2 border border-solid border-white/80 text-white text-xs uppercase grow-0">Highlights</span>
            </div>
            <app-date-spettacolo [spettacolo]="spettacolo_evidenza!" colore="light" class="mb-4 w-full"></app-date-spettacolo>
            <div class="relative mb-4 text-white">
                <h1 class="font-bold text-2xl md:text-3xl uppercase">{{spettacolo_evidenza!.compagnia}}</h1>
                <span class="font-mono text-xl md:text-2xl italic">{{spettacolo_evidenza!.spettacolo}}</span>
                <div class="top-0 -left-4 absolute bg-accent rounded w-[4px] h-full"></div>
            </div>
            <app-button-spettacolo classi="block text-center btn btn-primary btn-sm" [spettacolo]="spettacolo_evidenza!" [calendario]="spettacolo_evidenza!.calendario || []"></app-button-spettacolo>
        </div>
    </ng-container>

    <ng-container *ngIf="showDefaultVideo && !loading">
        <video #video (pause)="onPause($event)" [autoplay]="true" [muted]="true" [loop]="true" class="home-media-asset" oncontextmenu="return false;" disablePictureInPicture playsinline [src]="(getVideoSrc() | file)"></video>
        <button type="button" class="home-media-mute" (click)="onMute(muted)" [attr.aria-label]="muted ? 'Attiva audio' : 'Disattiva audio'">
            <i class="bi text-2xl lg:text-3xl" [ngClass]="{'bi-volume-mute-fill': muted, 'bi-volume-up-fill': !muted}"></i>
        </button>
    </ng-container>
</div>

<section class="flex lg:flex-row flex-col justify-evenly items-start lg:items-center gap-8 px-8 md:px-16 lg:px-64 py-16 lg:py-32">
    <div class="basis-2/5">
        <h1 class="mb-4 font-medium text-2xl md:text-4xl">I prossimi spettacoli</h1>
        <a class="cta-link" routerLink="/stagione">Scoprili tutti</a>
    </div>
    <div class="font-mono text-base text-justify basis-2/5">
        <p>Una nuova stagione: emozioni e suggestioni da vivere insieme su un palcoscenico e in un teatro che ogni sera si propongono di aprire una finestra su un mondo. Spettacoli divertenti, alcune volte pieni di gioia o piccole inquietudini, spesso con una riflessione in più sulla realtà di oggi.</p>
    </div>
</section>

<app-slider (onChangeSlide)="onChangeSlide($event)" [loop]="false" [grabCursor]="true" [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': { slidesPerView: 1, spaceBetween: 10, }, '@1.00': { slidesPerView: 1, spaceBetween: 20, centeredSlides: true }, '@1.25': { slidesPerView: 1.175, spaceBetween: 20, centeredSlides: true }, '@1.50': { slidesPerView: 1.175, spaceBetween: 20, centeredSlides: true }}" [sliderLength]="spettacoli.length" [evidenza]="true">
    <swiper-slide [lazy]="true" *ngFor="let spettacolo of spettacoli; let i = index">
        <app-spettacolo-box [spettacolo]="spettacolo" *ngIf="i <= (active + 1) "></app-spettacolo-box>
    </swiper-slide>
</app-slider>

<section class="hidden relative lg:flex items-center w-full h-[350px] overflow-clip">    
    <app-stagione-home class="absolute w-full md:w-auto h-auto md:h-full img-stagione" id="img-stagione"></app-stagione-home>    
</section>

<section class="flex lg:flex-row flex-col-reverse justify-between items-center gap-y-8 mb-32 pt-24 lg:pt-0" *ngIf="stagione">

    <div class="flex flex-row gap-4 w-full lg:w-1/2 h-[35vh] md:h-[50vh] lg:h-auto">
        <div class="w-1/3"><img #img_stagione1 [src]="(stagione.img_1 + '?type=spettacolo' | image)" alt="Stagione" class="h-full object-cover" (error)="img_stagione1.style.display = 'none'"></div>
        <div class="w-1/3"><img #img_stagione2 [src]="(stagione.img_2 + '?type=spettacolo' | image)" alt="Stagione" class="h-full object-cover" (error)="img_stagione2.style.display = 'none'"></div>
        <div class="w-1/3"><img #img_stagione3 [src]="(stagione.img_3 + '?type=spettacolo' | image)" alt="Stagione" class="h-full object-cover" (error)="img_stagione3.style.display = 'none'"></div>
    </div>

    <div class="px-8 md:px-16 lg:px-32 w-full lg:w-1/2">
        <h1 class="mb-4 font-medium text-2xl lg:text-4xl">
            <span class="relative decoration stagione">
                {{stagione.titolo}}
            </span>
        </h1>
        <p class="mb-8 font-mono text-base text-justify" [innerHTML]="stagione.descrizione"></p>
        <div class="flex flex-wrap gap-4">
            <a class="block w-fit btn btn-primary" target="_blank" [href]="stagione.link" *ngIf="stagione.button && stagione.link">{{stagione.button}}</a>
            <a class="block w-fit btn btn-primary" target="_blank" [href]="stagione.link_2" *ngIf="stagione.button_2 && stagione.link_2">{{stagione.button_2}}</a>
            <a class="block w-fit btn btn-primary" target="_blank" [href]="stagione.link_3" *ngIf="stagione.button_3 && stagione.link_3">{{stagione.button_3}}</a>
            <a class="block w-fit btn btn-primary" target="_blank" [href]="stagione.link_4" *ngIf="stagione.button_4 && stagione.link_4">{{stagione.button_4}}</a>
        </div>
    </div>
</section>

<section class="relative bg-light mt-24 lg:mt-48 pb-24 lg:pb-48">
    <img src="../../../assets/images/freccia.svg" class="-top-24 left-0 lg:left-16 absolute" alt="">

    <!--SLIDER NOTIZIE-->
    <app-slider [loop]="false" [navigation]="true" [grabCursor]="true" [sliderLength]="news.length" [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': { slidesPerView: 2, spaceBetween: 20, }, '@1.00': { slidesPerView: 3, spaceBetween: 40, }, '@1.50': { slidesPerView: 3, spaceBetween: 40 }}" [titolo_padding]="'pb-8 pt-32'" [titolo]="'Ultime dal teatro'" [titolo_button]="true" [titolo_button_text]="'vedi tutto'" [titolo_button_link]="'/news'">
        <swiper-slide [lazy]="true" *ngFor="let notizia of news" class="h-auto">
            <app-news-box [notizia]="notizia"></app-news-box>
        </swiper-slide>
    </app-slider>
    
    <!--ARCHIVIO-->
    <section class="lg:px-container pt-32 lg:pt-48 pb-16">
        <div class="flex lg:flex-row flex-col-reverse bg-black">
            <div class="flex flex-col justify-center gap-8 bg-dark p-8 md:p-16 lg:p-24 w-full lg:w-1/2 text-white">                
                <span class="mb-0 md:mb-16 p-2 border border-solid w-fit text-xs uppercase grow-0">Storie</span>                
                <h1 class="text-accent text-2xl lg:text-4xl">Le teche del teatro</h1>
                <p class="mb-0 font-mono text-base">Un luogo digitale dove ritrovare artisti, locandine, fotografie e ricordi che hanno fatto la nostra storia.
                    <br/><br/>Dal debutto negli anni Ottanta ai grandi nomi della scena contemporanea, l’archivio racconta l’evoluzione di un teatro che ha sempre saputo coniugare popolare e qualità, accogliendo generazioni di spettatori e protagonisti.
                    <br/><br/>Un viaggio nel tempo e nella cultura, per riscoprire come - sera dopo sera - il Teatro Colosseo è diventato parte della vita culturale italiana.
                </p>                
                <a class="w-fit btn btn-primary" href="https://archivio.teatrocolosseo.it" target="_blank">VAI ALL'ARCHIVIO</a>                
            </div>
            <div class="relative bg-[url('assets/images/home/archivio.png')] bg-cover bg-center lg:bg-right w-full lg:w-1/2 h-96 lg:h-auto overflow-clip">
                <div class="top-0 left-0 absolute bg-black w-full h-full overlayNero"></div>
                <div class="!-right-8 lg:!-right-16 w-1/2 md:w-72 h-1/2 md:h-72 overflow-clip logo">
                    <div class="wrapper">
                        <img class="c" src="../../../assets/images/logo-c.svg" alt="Logo Teatro Colosseo">
                        <img class="circle" id="logo-circle-archivio" src="../../../assets/images/logo-circle.svg" alt="Logo Teatro Colosseo">
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>

<!--CARD E BIGLIETTI ONLINE-->
<section class="flex lg:flex-row flex-col mb-24">    
    <div class="bg-accent p-8 md:p-16 lg:p-32 w-full lg:w-1/2">
        <div class="flex flex-col items-center gap-8 h-full">
            <img src="../../../assets/images/home/card.png" alt="Colosseo Card" class="flex-shrink h-[40vh] min-h-[40vh] lg:min-h-[80vh] object-cover img-card">
            
            <h1 class="text-2xl lg:text-4xl">Colosseo Card</h1>
            <div class="flex flex-col justify-between items-center gap-8 h-full">
                <p class="mb-0 lg:w-2/3 font-mono text-base text-center">È possibile acquistare o regalare una Colosseo Card che permette al beneficiario di scegliere e prenotare quali spettacoli vedere.</p>
                <a class="w-auto btn btn-outln" href="https://teatrocolosseo.eventim-inhouse.de/webshop/webticket/shop?coupon" target="_blank">SCOPRI</a>
            </div>                
        </div>
    </div>
    <div class="bg-dark p-8 md:p-16 lg:p-32 w-full lg:w-1/2">
        <div class="flex flex-col items-center gap-8 h-full text-white">
            <img src="../../../assets/images/home/biglietti.png" alt="Biglietti Online" class="flex-shrink min-h-[40vh] lg:min-h-[80vh] object-cover img-biglietti">                
            <h1 class="text-2xl lg:text-4xl">Biglietti Online</h1>
            <div class="flex flex-col justify-between items-center gap-8">
                <p class="mb-0 lg:w-2/3 font-mono text-base text-center">Acquista online i biglietti per gli spettacoli del Teatro Colosseo in modo facile, sicuro e veloce attraverso il circuito TicketOne oppure fisicamente presso la nostra biglietteria.</p>
                <a class="w-auto btn btn-outln-white" href="https://teatrocolosseo.eventim-inhouse.de/" target="_blank">SCOPRI</a>
            </div>                
        </div>
    </div>    
</section>